import { render } from "./second_question.vue?vue&type=template&id=7acf6015&scoped=true"
import script from "./second_question.vue?vue&type=script&lang=js"
export * from "./second_question.vue?vue&type=script&lang=js"

import "./second_question.vue?vue&type=style&index=0&id=7acf6015&scoped=true&lang=css"

import exportComponent from "/Users/matsushitamasaya/webex/setouchi-webapp2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7acf6015"]])

export default __exports__